import {COMPLETION_MODAL} from '@/constants';

export default {
  iframe: {
    origin: {
      test: 'https://www-test.tbank.ru/',
      prod: 'https://www.tbank.ru/',
    },
    path: 'cards/debit-cards/black/iframe/form/ny25/',
  },
  isProjectFinishedModalActive: true,
  secretCode: {
    key: 'secret',
    code: '746wzi9j8b',
  },
  currentTypeCompletionModal: COMPLETION_MODAL.ProjectFinished,
  projectDateEnd: '2025-01-15',
} as const;
